import { render, staticRenderFns } from "./BusinessHoursDisplay.vue?vue&type=template&id=1fa4ae0b&scoped=true"
import script from "./BusinessHoursDisplay.vue?vue&type=script&lang=js"
export * from "./BusinessHoursDisplay.vue?vue&type=script&lang=js"
import style0 from "./BusinessHoursDisplay.vue?vue&type=style&index=0&id=1fa4ae0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa4ae0b",
  null
  
)

export default component.exports